import { InvoiceStatus, PlanContractType, Subscription_DelinquentType, Subscription_SubscriptionStatus } from "@alch/protobufs-es/billing/billing_core_pb";
import z$1 from "zod";
//#region src/billing/billing.ts
const BillingAddress = z$1.object({
	line1: z$1.string().nonempty(),
	line2: z$1.string(),
	city: z$1.string().nonempty(),
	state: z$1.string(),
	postalCode: z$1.string().nonempty(),
	country: z$1.string().nonempty()
});
/**
* Tax information for a team's invoices as defined by Orb.
*
* @see https://docs.withorb.com/api-reference/customer/update-customer#body-tax-id
*/
const TaxId = z$1.object({
	country: z$1.string(),
	type: z$1.string(),
	value: z$1.string()
});
const PublicInvoiceStatus = z$1.nativeEnum({
	ISSUED: InvoiceStatus.ISSUED,
	PAID: InvoiceStatus.PAID,
	PAYMENT_FAILED: InvoiceStatus.PAYMENT_FAILED
});
const SubscriptionStatus = Subscription_SubscriptionStatus;
const SubscriptionDelinquentType = Subscription_DelinquentType;
const SubscriptionPlanContractType = PlanContractType;
//#endregion
export { BillingAddress, PublicInvoiceStatus, SubscriptionDelinquentType, SubscriptionPlanContractType, SubscriptionStatus, TaxId };

//# sourceMappingURL=billing.js.map